import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

export default function AppHeader({ title = "WEDFLOW" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="border-b border-neutral-200 bg-white sticky top-0 z-30">
      <div className="max-w-[1240px] mx-auto px-4 md:px-8 h-14 md:h-[72px] flex items-center justify-between">
        <Link
          to="/dashboard"
          className="flex items-center gap-2 select-none"
          data-testid="app-brand"
        >
          <span
            aria-hidden
            className="inline-block w-1.5 h-1.5 rounded-full"
            style={{ background: "#c9a86a" }}
          />
          <span className="font-display tracking-[0.28em] text-[12px] md:text-sm font-medium text-neutral-950">
            {title}
          </span>
        </Link>

        <div className="flex items-center gap-2 md:gap-3">
          {user && (
            <div className="flex items-center gap-2" data-testid="user-pill">
              {user.picture ? (
                <img
                  src={user.picture}
                  alt={user.name}
                  className="w-7 h-7 md:w-8 md:h-8 rounded-full object-cover border border-neutral-200"
                  referrerPolicy="no-referrer"
                />
              ) : (
                <span className="w-7 h-7 md:w-8 md:h-8 rounded-full grid place-items-center bg-neutral-100 text-[12px] font-medium text-neutral-700">
                  {(user.name || user.email || "?").slice(0, 1).toUpperCase()}
                </span>
              )}
              <span className="hidden sm:block text-[13px] text-neutral-700 max-w-[160px] truncate">
                {user.name || user.email}
              </span>
            </div>
          )}
          <button
            type="button"
            onClick={async () => {
              await logout();
              navigate("/", { replace: true });
            }}
            data-testid="logout-btn"
            className="border border-neutral-200 rounded-full px-3 md:px-4 py-1.5 md:py-2 text-[11px] md:text-[12px] tracking-wide text-neutral-600 hover:text-neutral-900 hover:border-neutral-400 transition-all"
          >
            Esci
          </button>
        </div>
      </div>
    </header>
  );
}
